import { useState, useEffect } from 'react';

export const useFixedTitle = distance => {
    const [showFixedTitle, setShowFixedTitle] = useState(false);

    const handleScroll = () => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        setShowFixedTitle(scrollTop > distance);
    };

    useEffect(
        () => {
            window.addEventListener('scroll', handleScroll);

            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        },
        [distance],
    );

    return showFixedTitle;
};
